module.exports = __webpack_public_path__ + "img/bjt.2375d934.png";